import { type CardRowAttributes } from './generated/CardRowAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { HasCardLayoutHierarchy } from './concerns/HasCardLayoutHierarchy';
import { JsonQuerySerialization } from './concerns/JsonQuerySerialization';

interface CardRow extends CardRowAttributes {}

@model
@HasCardLayoutHierarchy
@JsonQuerySerialization
class CardRow extends ApplicationModel {
  // Start auto-generated
  static typename: 'CardRow' = 'CardRow';
  get typename(): 'CardRow' {
    return 'CardRow';
  }

  static inputType = 'CardRowAttributes';

  static fields = {
    divider: attr({ writable: true, readable: true }),
    id: attr({ writable: true, readable: true }),
    firstGroup: attr.belongsTo({
      writeShape: ['id', 'fields'],
      readable: true,
      typename: 'CardGroup',
    }),
    secondGroup: attr.belongsTo({
      writeShape: ['id', 'fields'],
      readable: true,
      typename: 'CardGroup',
    }),
  };
  // End auto-generated

  get groups() {
    return [this.firstGroup, this.secondGroup];
  }

  get fields() {
    return this.groups.flatMap(group => group.fields);
  }

  get empty() {
    return this.fields.length === 0 && !this.divider;
  }

  /**
   * Find a CardGroup in the row by its groupId.
   *
   * @param {string} groupId The group ID.
   * @returns {CardGroup} The group.
   */
  getGroup(groupId) {
    return this.groups.find(group => group.id === groupId);
  }

  /**
   * Find the CardGroup in the row contains the specified field.
   *
   * @param {string} cardFieldId The ID of the CardField
   * @returns {CardGroup} The CardGroup that contains the field.
   */
  getGroupForField(cardFieldId) {
    return this.groups.find(group => group.getFieldById(cardFieldId));
  }

  /**
   * Compares another CardRow to this, and returns whether they are equal or not.
   *
   * @param {CardRow} otherRow The CardRow to compare.
   */
  isEqualTo(otherRow) {
    return (
      this.divider === otherRow.divider &&
      this.firstGroup.isEqualTo(otherRow.firstGroup) &&
      this.secondGroup.isEqualTo(otherRow.secondGroup)
    );
  }
}

export default CardRow;
